<!-- ANTES DE ENVIAR O NUMERO DE TELEFONE -->
<form [formGroup]="form">
    <div class="row" *ngIf="!sended">
        <div class="col-12">
            <p class="text-center">Ótimo! Agora, precisamos de uma foto dos seus documentos.</p>
            <p class="text-center">Para isso, vamos enviar um link para o seu celular. Basta clicar nele e enviar a
                foto, conforme as instruções
                no link.</p>
        </div>
    </div>

    <div class="row mt-4" *ngIf="!sended">
        <div class="col-12">
            <p class="text-center">Confirme por favor seu número de telefone.</p>
            <div class="col-12 d-flex justify-content-center">
                <div class="form-group">
                    <input type="tel" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                        formControlName="telefone"
                        [ngClass]="form.controls.telefone.valid && !form.controls.telefone.untouched ? 'is-valid' : !form.controls.telefone.untouched ? 'is-invalid' : ''"
                        mask="(00) 0 0000-0000">
                    <input-feedback label="Telefone" [control]="form.controls.telefone"></input-feedback>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="row mt-4" *ngIf="!sended">
    <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-primary" [disabled]="form.invalid" (click)="next()">Continuar</button>
    </div>
</div>
<!-- FIM ANTES DE ENVIAR O NUMERO DE TELEFONE -->

<!-- DEPOIS DE ENVIAR O NUMERO DE TELEFONE -->
<div class="row" *ngIf="sended">
    <div class="col-12 d-flex justify-content-center">
        <p>Tudo certo? Assim que enviar as fotos do seus documentos, basta clicar em continuar.</p>
    </div>
</div>

<div class="row" *ngIf="sended">
    <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-primary" (click)="documentsSended()">Documentos enviados, continuar</button>
    </div>
</div>

<div class="row mt-4" *ngIf="sended">
    <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-light" (click)="dontReceiveLink()">Não recebi o link</button>
    </div>
</div>
<!-- FIM DEPOIS DE ENVIAR O NUMERO DE TELEFONE -->